'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyGsap = void 0;
const gsap_1 = require("gsap");
const ScrollTrigger_1 = require("gsap/ScrollTrigger");
gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger);
class MyGsap {
    constructor() {
        this.UNDER_PC_WIDTH = '1199px';
        this.OVER_PC_WIDTH = '1200px';
        const matchMedia = gsap_1.gsap.matchMedia();
        // 1199px以下のとき
        matchMedia.add(`(max-width: ${this.UNDER_PC_WIDTH})`, () => {
            this.reasonFadeInSp();
            this.courseFadeInSp();
        });
        // 1200px以上のとき
        matchMedia.add(`(min-width: ${this.OVER_PC_WIDTH})`, () => {
            this.reasonFadeInPc();
            this.courseFadeInPc();
        });
    }
    // 学科紹介 スマホ
    reasonFadeInSp() {
        const elements = gsap_1.gsap.utils.toArray('.bulletTopReason');
        elements.forEach(element => {
            //
            gsap_1.gsap.fromTo(element, {
                autoAlpha: 0,
                y: 100,
            }, {
                autoAlpha: 1,
                y: 0,
                scrollTrigger: {
                    trigger: element,
                    start: 'top center',
                    // markers: true, // マーカー表示
                }
            });
        });
    }
    reasonFadeInPc() {
        //
        gsap_1.gsap.fromTo('.bulletTopReason', {
            autoAlpha: 0,
            y: 100,
        }, {
            autoAlpha: 1,
            y: 0,
            scrollTrigger: {
                trigger: '.paramTopReason',
                start: 'top center',
                // markers: true, // マーカー表示
            },
            stagger: {
                each: 0.2,
                from: 'start',
            }
        });
    }
    // 学科紹介 スマホ
    courseFadeInSp() {
        const elements = gsap_1.gsap.utils.toArray('.bulletTopCourse');
        elements.forEach(element => {
            //
            gsap_1.gsap.fromTo(element, {
                autoAlpha: 0,
                y: 100,
            }, {
                autoAlpha: 1,
                y: 0,
                scrollTrigger: {
                    trigger: element,
                    start: 'top center',
                    // markers: true, // マーカー表示
                }
            });
        });
    }
    courseFadeInPc() {
        //
        gsap_1.gsap.fromTo('.bulletTopCourse', {
            autoAlpha: 0,
            y: 100,
        }, {
            autoAlpha: 1,
            y: 0,
            scrollTrigger: {
                trigger: '.paramTopCourse',
                start: 'top center',
                // markers: true, // マーカー表示
            },
            stagger: {
                each: 0.2,
                from: 'start',
            }
        });
    }
}
exports.MyGsap = MyGsap;
exports.default = MyGsap;
